import { applyMiddleware, compose, createStore } from 'redux'
// import the root reducer
import rootReducer, {defaultState} from './rootReducer'

import { persistStore } from 'redux-persist'
import thunkMiddleware from 'redux-thunk'
import verify from './admin/verifyMiddleware'

const store = createStore(
    rootReducer,
    defaultState,
    compose(
        applyMiddleware(verify),
        applyMiddleware(thunkMiddleware),
    ),
)

export const persistor = persistStore(store)

export default store
